export default [
  {
    path: '/devices',
    name: 'devices',
    component: () => import('@/views/Devices/Devices.vue'),
    meta: {
      pageTitle: 'List All Devices',
      breadcrumb: [
        {
          text: 'Devices',
          active: true,
        },
      ],
    },
  },
  {
    path: '/devices/addDevice',
    name: 'addDevice',
    component: () => import('@/views/Devices/AddDevice/AddDevice.vue'),
    meta: {
      pageTitle: 'Add Device',
      breadcrumb: [
        {
          text: 'Devices',
          to: '/devices', // Add the link back to the devices list
          active: false,
        },
        {
          text: 'Add Devices',
          active: true,
        },
      ],
    },
  },
  {
    path: '/devices/:id/:tab?',
    component: () => import('@/views/Devices/Device/Device.vue'),
    name: 'device',
    meta: {
      pageTitle: 'Device',
      breadcrumb: [
        {
          text: 'Devices',
          to: '/devices',
          active: false,
        },
      ],
    },
  },
]
